import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { ToastContainer } from "react-toastify"
import { Routes, Route, useNavigate, useLocation } from "react-router-dom"
import routes from "../routes"
import {
  getBasicValuationReport,
  getValuationReport,
  getValuationWarnings,
  getWidgetInfo,
  setCurrentValuation,
  signOutAllValuations,
} from "../../redux/valuations.slice"
import {
  getURLValuationId,
  isIOS,
  isNavbarRoute,
  isValuationLandingRoute,
} from "../../utils/helpers"
import "react-toastify/dist/ReactToastify.min.css"
import { requestNotificationsToken } from "../../firebase"
import {
  setDeviceNotifToken,
  setStateNotificationToken,
} from "../../redux/notification.slice"
import useParamNavigation from "../../utils/navigation"
import Navigation from "../../components/Navigation"
import ErrorPage from "../../pages/ErrorPage"
import { useTranslation } from "react-i18next"

const MainShell = () => {
  const navigate = useNavigate()
  const { valuations, currentValuation, getBasicError, getReportError } =
    useSelector((store) => store.valuationsDetails)
  const { notificationToken } = useSelector(
    (store) => store.notificationsDetails
  )
  const dispatch = useDispatch()
  const location = useLocation()
  const { pathWithPropId } = useParamNavigation()
  const { t } = useTranslation()

  useEffect(() => {
    document.title =
      "MiCasa México - " +
      t(`page-title.${window.location.pathname.split("/")[3]}`)
  }, [window.location.pathname])

  useEffect(() => {
    const handleNotificationToken = async () => {
      if (isIOS()) return
      if (!window.location.pathname.includes("home")) return
      if (Notification?.permission !== "granted") return
      if (!currentValuation || !valuations[currentValuation]) return

      const notifToken = await requestNotificationsToken()
      if (notifToken && notifToken !== notificationToken) {
        console.info("Saving the new notification token:", notifToken)
        dispatch(setStateNotificationToken({ notificationToken: notifToken }))
        dispatch(
          setDeviceNotifToken({
            token: notifToken,
            authToken: valuations[currentValuation].authToken,
          })
        )
      }
    }

    handleNotificationToken()
  }, [notificationToken])

  const [prevValuationId, setPrevValuationId] = useState(null)

  useEffect(() => {
    const manageRedirects = async () => {
      const urlValuationId = getURLValuationId()
      if (
        window.location.pathname.split("/")[1] === "valuations" &&
        window.location.pathname.split("/").length > 2
      ) {
        if (currentValuation === "undefined" || currentValuation === "null") {
          navigate("/" + routes["root"].children["default"].path)
        } else if (
          currentValuation !== urlValuationId &&
          !Object.keys(valuations).find(
            (valuation) => valuation === urlValuationId
          )
        ) {
          dispatch(signOutAllValuations())
          dispatch(setCurrentValuation(urlValuationId))
        } else if (
          valuations &&
          Object.keys(valuations).find(
            (valuation) => valuation === urlValuationId
          )
        ) {
          const isAuthenticated = !!valuations[urlValuationId].authToken
          if (!isAuthenticated) {
            if (
              !isValuationLandingRoute(location.pathname) &&
              !location.pathname.endsWith("sign-in") &&
              !location.pathname.endsWith("number-verification") &&
              !location.pathname.endsWith("terms-and-conditions")
            ) {
              navigate(
                pathWithPropId(routes["main-shell"].children["default"].path)
              )
            }
          } else {
            if (
              isValuationLandingRoute(location.pathname) ||
              location.pathname.endsWith("sign-in") ||
              location.pathname.endsWith("number-verification")
            ) {
              navigate(
                pathWithPropId(routes["main-shell"].children["home"].path)
              )
            }
          }
        } else {
          if (prevValuationId !== urlValuationId) {
            navigate(
              pathWithPropId(routes["main-shell"].children["default"].path)
            )
            dispatch(getBasicValuationReport(urlValuationId))
            setPrevValuationId(urlValuationId)
          }
        }
      }
    }
    manageRedirects()
  }, [navigate, valuations, currentValuation, dispatch, location.pathname])

  useEffect(() => {
    if (valuations[currentValuation]?.authToken) {
      dispatch(
        getValuationReport({
          valuationId: currentValuation,
          authToken: valuations[currentValuation].authToken,
        })
      )
      dispatch(
        getWidgetInfo({
          authToken: valuations[currentValuation].authToken,
        })
      )
    }
  }, [valuations[currentValuation]?.authToken])

  useEffect(() => {
    const warningIds = valuations[
      currentValuation
    ]?.valuation?.valuationWarnings?.map((warning) => warning.id)
    if (warningIds?.length && valuations[currentValuation]?.authToken) {
      dispatch(
        getValuationWarnings({
          valuationId: currentValuation,
          authToken: valuations[currentValuation].authToken,
          codes: warningIds,
        })
      )
    }
  }, [valuations[currentValuation]?.valuation?.valuationWarnings])

  return (
    <div>
      <ToastContainer
        position="bottom-center"
        autoClose={2000}
        hideProgressBar={true}
        closeButton={false}
        limit={2}
      />
      <Routes>
        <Route path={""} element={routes["main-shell"].element}>
          {Object.keys(routes["main-shell"].children).map((key, index) => (
            <Route
              key={`main-route-${index}`}
              exact={routes["main-shell"].children[key].exact}
              path={routes["main-shell"].children[key].path}
              element={
                getBasicError ||
                getReportError ||
                valuations[currentValuation]?.valuation?.status ? (
                  <ErrorPage type="error" />
                ) : (
                  routes["main-shell"].children[key].element
                )
              }
            />
          ))}
        </Route>
      </Routes>
      {isNavbarRoute(location.pathname) &&
        !getBasicError &&
        !getReportError &&
        !valuations[currentValuation]?.valuation?.status && <Navigation />}
    </div>
  )
}

export default MainShell
